<template>
    <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
        :opacity="detailsOpacity" 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M11.6899 6.63921C11.8752 6.4536 12.1756 6.4536 12.3609 6.63921C12.5461 6.82482 12.5461 7.12576 12.3609 7.31137L11.3498 8.32428C11.1644 8.51001 10.8635 8.51015 10.678 8.32458C10.4926 8.13926 10.4925 7.83884 10.6777 7.65335L11.6899 6.63921Z" 
        :fill="color"/>
        <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M9.65367 8.67936C9.83906 8.49363 10.14 8.49349 10.3255 8.67906C10.5108 8.86438 10.511 9.1648 10.3258 9.35029L6.32267 13.3608C6.1374 13.5464 5.83702 13.5464 5.65174 13.3608L3.63895 11.3443C3.45368 11.1587 3.45368 10.8578 3.63895 10.6721C3.82423 10.4865 4.12461 10.4865 4.30988 10.6721L5.98721 12.3525L9.65367 8.67936Z" 
        :fill="color"/>
        <path 
        :opacity="detailsOpacity" 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M11.6899 2.63921C11.8752 2.4536 12.1756 2.4536 12.3609 2.63921C12.5461 2.82482 12.5461 3.12576 12.3609 3.31137L11.3498 4.32428C11.1644 4.51001 10.8635 4.51015 10.678 4.32458C10.4926 4.13926 10.4925 3.83884 10.6777 3.65335L11.6899 2.63921Z" 
        :fill="color"/>
        <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M9.65367 4.67936C9.83906 4.49363 10.14 4.49349 10.3255 4.67906C10.5108 4.86438 10.511 5.1648 10.3258 5.35029L6.32267 9.36077C6.1374 9.54638 5.83702 9.54638 5.65174 9.36077L3.63895 7.3443C3.45368 7.15869 3.45368 6.85775 3.63895 6.67214C3.82423 6.48653 4.12461 6.48653 4.30988 6.67214L5.98721 8.35254L9.65367 4.67936Z" 
        :fill="color"/>
    </svg>
</template>
<script>
    export default {
        props:['width','height','color','detailsOpacity'],
    }
</script>

<style scoped>
</style>
